import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Button, Box, Flex, Heading, Card } from 'rebass/styled-components';

const TimesWrapper = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
`;

const TimesText = styled.span`
  display: block;
  font-weight: 300;
  font-size: 12px;

  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const TimesIndicator = styled(Box)`
  display: block;
  background: rgb(188, 255, 235);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 4px;

  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const DayMobile = styled.div`
  display: block;

  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const DayFull = styled.span`
  display: block;

  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const AvailabilitiesLoadingErrorWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const AvailabilitiesLoadingErrorText = styled.div`
  margin-top: 20px;
  font-weight: 500;
  &.error {
    color: #f9a394;
  }
  &.title {
    font-weight: 700;
  }
`;

const ExpandedRow = styled.div`
  padding: 20px;
  border-width: 2px 0;
  border-color: #4467e2;
  border-style: solid;
  position: relative;
`;

const SlotButton = styled(Button)`
  margin: 6px;
  width: auto;
  border-width: 1px;
  font-size: 14px;
`;

export interface ICalendarGrid {
  selectedDate: string | null;
  setSelectedDate: (date: string | null) => void
}

const CalendarGridMini = ({ selectedDate, setSelectedDate }: ICalendarGrid) => {
  const [currentMonth, setCurrentMonth] = useState<Date>(moment(selectedDate).toDate())

  useEffect(() => {
  }, [])

  useEffect(() => {
  }, [currentMonth])

  useEffect(() => {
    setCurrentMonth(moment(selectedDate).toDate())
  }, [selectedDate])

  const renderHeader = () => {
    const dateFormat = 'MMMM YYYY';

    return (
      <div className="header row flex-middle">
        <div className="col col-start">
          <div className="icon" onClick={prevMonth}>
            {'<'}
          </div>
        </div>
        <div className="col col-center">
          <span>{moment(currentMonth).format(dateFormat)}</span>
        </div>
        <div className="col col-end" onClick={nextMonth}>
          <div className="icon">{'>'}</div>
        </div>
      </div>
    );
  };

  const renderDays = () => {
    const dateFormat = 'dd';
    const days = [];

    let startDate = moment(currentMonth).startOf('week');
    let startDateMob = moment(currentMonth).startOf('week');
    startDate.add(-1, 'days').format(dateFormat);
    startDateMob.add(-1, 'days').format('dd');
    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col col-center" key={i}>
          <DayFull>{startDate.add(1, 'days').format(dateFormat)}</DayFull>
        </div>
      );
    }

    return <div className="days row rowDays">{days}</div>;
  };

  const renderCells = () => {// (slots, loading, error, expandDay) => {
    const monthStart = moment(currentMonth).startOf('month');
    const monthEnd = moment(currentMonth).endOf('month');
    const startDate = moment(monthStart).startOf('week');
    const endDate = moment(monthEnd).endOf('week');

    const dateFormat = 'D';
    const rows = [];

    let days = [];
    let day = startDate;
    let formattedDate = '';

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = moment(day).format(dateFormat);
        const clone = moment(day)
          .format('MM/DD/YYYY')
          .toString();
        
        days.push(
          <Box
            className={`col cell ${!moment(day).isSame(moment(monthStart), 'month')
              ? 'nextMonth' :
              moment(day).isSame(moment(selectedDate), 'day')
                ? 'selected'
                : moment(day).isBefore(moment(), 'day') ? 'disabled'
                  : ''
              }`}
            key={day.format()}
            onClick={e => {
              if (moment(day).isBefore(moment(), 'day')) return;
              onDateClick(clone);
            }}
          >
            <span className="number">{formattedDate}</span>
          </Box>
        );
        day = moment(day).add(1, 'days');
      }
      rows.push(
        <Box className="row" key={day.format()}>
          {days}
        </Box>
      );

      days = [];
    }
    return (
      <div className="body">
        {rows}
      </div>
    );
  };

  const onDateClick = (day: string) => {
    console.log(day)
    setSelectedDate(day !== selectedDate ? day : null)
  };

  const nextMonth = () => {
    setCurrentMonth(moment(currentMonth).add(1, 'months').toDate())
  };

  const prevMonth = () => {
    setCurrentMonth(moment(currentMonth).add(-1, 'months').toDate())
  };

  return (
    <Flex flexDirection={'column'} flex={1} maxWidth='700px' mb={[3,0,0]}>
      {/* <Heading style={{ fontSize: '24px' }} mb={3}>Your Calendar</Heading> */}
      <div className='calendarMini'>
        <Flex flexDirection={'column'} style={{ borderRadius: '20px', paddingBottom: '20px' }}>
          {renderHeader()}
          {renderDays()}

          {renderCells()}
          {/* (data, loading, error, selectedDate)} */}
        </Flex>
      </div>
    </Flex>
  );
}

export default CalendarGridMini;
